import { makeStyles } from '@material-ui/core/styles'
import ConfigAccordionBase from './ConfigAccordionBase'
import { Text } from '../../1elements'
import WelcomeMessage from './WelcomeMessage'
import FormTextField from '../../2compounds/FormTextField'
import TemplateNameDropdown from '../../2compounds/Select/TemplateNameDropDown'

const WelcomeMessageAccordion = ({
  onEditMode,
  templateOption,
  setTemplateOption,
  templateOptions,
  formik
}) => {
  const classes = useStyles()
  if (!templateOption) templateOption = ''

  const changeTemplateName = e => {
    templateOption.template_name = e
    formik.setFieldValue('templateName', e)
    formik.handleChange(e)
  }
  const changeTitle = e => {
    templateOption.title = e
    formik.setFieldValue('title', e)
    formik.handleChange(e)
  }
  const changeFooter = e => {
    templateOption.footer = e
    formik.setFieldValue('footerDescription', e)
    formik.handleChange(e)
  }

  const changeDescription = e => {
    templateOption.description = e
    formik.setFieldValue('description', e)
    formik.handleChange(e)
  }

  return (
    <ConfigAccordionBase
      className={classes.root}
      label={'Template'}
      onEditMode={onEditMode}
    >
      <div className={classes.formDiv}>
        <div className={classes.templateDiv}>
          <Text type='fieldLabel'>Template Name</Text>
          <TemplateNameDropdown
            onEditMode={onEditMode}
            value={templateOption}
            onChange={setTemplateOption}
            templateOptions={templateOptions}
            disabled={true}
          />
        </div>
        <FormTextField
          value={formik.values.templateName}
          onChange={changeTemplateName}
          name={'templateName'}
          required={true}
          disabled={!onEditMode}
        />
        <div className={classes.filedDiv}>
          <FormTextField
            value={formik.values.title}
            onChange={changeTitle}
            name={'title'}
            label={'Title'}
            required={true}
            disabled={!onEditMode}
          />
          <FormTextField
            rows={5}
            value={formik.values.description}
            onChange={changeDescription}
            name={'description'}
            label={'Description'}
            required={true}
            disabled={!onEditMode}
          />
          <FormTextField
            value={formik.values.footerDescription}
            onChange={changeFooter}
            name={'footerDescription'}
            label={'Footer Description'}
            required={true}
            disabled={!onEditMode}
          />
        </div>
      </div>
      <WelcomeMessage
        title={formik.values.title}
        description={formik.values.description}
        footerDescription={formik.values.footerDescription}
      />
    </ConfigAccordionBase>
  )
}

export default WelcomeMessageAccordion

const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    alignItems: 'start'
  },
  formDiv: {
    maxWidth: 350
  },
  templateDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 20
  },
  filedDiv: {
    height: 280,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around'
  }
})
